import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {AssetReconciliationComponent} from "./asset-reconciliation.component";
import {PaginationModule} from "../pagination/pagination.module";
import {DealKeySelectionDialogComponent} from "./deal-key-selection-dialog.component";
import {BulkOrderItemSelectionDialogComponent} from "./bulk-order-item-selection-dialog.component";
import {FormHelpersModule} from "../form-helpers/form-helpers.module";

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    PaginationModule,
    FormHelpersModule,
  ],
  declarations: [
    AssetReconciliationComponent,
    DealKeySelectionDialogComponent,
    BulkOrderItemSelectionDialogComponent,
  ],
  exports: [
    AssetReconciliationComponent,
    DealKeySelectionDialogComponent,
    BulkOrderItemSelectionDialogComponent,
  ],
  entryComponents: [
    DealKeySelectionDialogComponent,
    BulkOrderItemSelectionDialogComponent,
  ],
})
export class AssetReconciliationModule {}
